import React from 'react';

export const PreloadImages = ({ imgSource }) => {
  return imgSource.map((item, ind) => (
    <img key={ind} src={item.src} alt={item.alt} style={{ display: 'none' }} />
  ));
};
